import styled from 'styled-components';

import { YatSprite } from '@pkg/components/YatSprite';

export const Heading = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 105%;
    text-align: center;
    letter-spacing: -0.03em;
    margin: 8px 0 0 0;
    padding: 0;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        /*  */
    }
`;

export const SubHeading = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.03em;
    color: #ffffff;
    opacity: 0.7;
    margin: 22px 0;
    padding: 0;
    max-width: 350px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        /*  */
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;
    gap: 8px;
    height: 100%;
    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        height: unset;
        padding: 70px 20px 40px 20px;
    }
`;

export const FaceScreamingIcon = styled(YatSprite)`
    font-size: 60px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 60px;
    }
`;

export const ActionsWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
`;
